export const CampaignConstants = {
  type: 'campaign',
  channels: {
    WEBOS: 'webos',
    CHANNEL01: 'channel01'
  },
  types: {
    SOFT: 'soft'
  },
  unlimitedIdentifier: 'unlimited',
  benefit: {
    category: {
      MF_DISCOUNT: 'mfDiscount',
      DATA: 'data'
    },
    type: {
      BASIC: 'basic',
      COMPLEX: 'complexTimeBenefit'
    },
    name: {
      DEFAULT: 'benefit',
      PROMO: 'promoBenefit'
    },
    UNLIMITED_CONSTANT_FROM_CAMPAIGN: 'UNLMTD'
  },
  acceptance: {
    SMS: 'send-sms',
    EMAIL: 'send-email',
    status: {
      GIVEN: 2,
      PENDING: 1,
      NOT_GIVEN: 0,
    }
  },
  deliveryOptions: {
    SOFT_ELECTRO: 'SOFT_ELECTRO',
    SOFT_EANEX: 'SOFT_EANEX',
    PIS: 'PIS',
    STO: 'STO'
  },
  submitActions: {
    WEBOS: 'webos',
    WEBOS_AGENT: 'webosAgent',
    ELECTRO: 'electro',
    STORE: 'store',
    OTHER_ADDRESS: 'otherAddress',
    P2P: 'p2p',
    EANEX: 'eAnex'
  },
  softElectro: {
    submitCodes: {
      SUCCESS: 0,
      GENERAL_ERROR: -1000
    }
  },
  Y_APP_FLAG: {
    YADV: 'YADV',
    STND: 'STND'
  },
  CAMPAIGN_OVERVIEW_LOCATION_QUERY: 'campaignOverviewLocationQuery'
};

export const CAMPAIGN_TYPE = {
  P2P: 'p2p',
  P2PDJ: 'p2p_dj',
  TP_UPSELL: 'tpUpsell',
  SOFT_RENEWAL: 'softRenewal'
};


